﻿import readCookie from '../universals/cookieReader';
import Recaptcha from '../universals/verifyRecaptcha';
import submitForm from './universalSubmission';
import initBannerSignupValidation from '../components/BannerSignup';

function validate(form, formType, devMode) {

    //Parsley has a dependency on jquery. So we can't remove Jquery till we change our validation library.
    const parsleyForm = $(form).parsley();
    const submitButton = form.querySelector('button[data-submitButton]');
    const errorMessage = (formType === 'landingpage' || formType === 'workshop') ? document.querySelector('span[data-error]') : undefined;
    //Browser
    const url = window.location.href;
    const referrer = window.document.referrer;
    //Form fields
    const formFields = form.querySelectorAll('input[data-formField], select[data-formField], textarea[data-formField]');
    //Success container
    const successId = form.dataset.successid;
    const successContainer = document.querySelector(`div[data-submissionsuccesscontainer="${successId}"]`);
    //Cookies
    const mktoCookie = readCookie('_mkto_trk');
    //Submission gateway
    let gateway;
    let mutinyFormName;
    let formLocation;
    switch (formType) {
        //formLocation we try to derive from the hidden form field itself. These only serve as backup incase they aren't defined. Like on the main footer form.
        case 'main':
            gateway = 'https://prod-46.eastus.logic.azure.com:443/workflows/e69cf7749c2c4a56a20ae22734bdb8e7/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=rP2MQmKNdBWUQDzc6tsZhi0NIPTHANdh6OINduIaO-E';
            mutinyFormName = 'Contact-Us-Form';
            formLocation = 'footer';
            break;
        case 'landingpage':
            gateway = 'https://prod-46.eastus.logic.azure.com:443/workflows/e69cf7749c2c4a56a20ae22734bdb8e7/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=rP2MQmKNdBWUQDzc6tsZhi0NIPTHANdh6OINduIaO-E';
            mutinyFormName = 'Landing-Page-Form';
            formLocation = 'landing-page';
            break;
        case 'workshop':
            gateway = 'https://prod-76.eastus.logic.azure.com/workflows/cf7e7ec806c94dc09eb8a8706dbadf06/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=iUxeF2Q41SSbZjEBqZc_W3zxTa4fDcoBMZ0vREmBcys';
            break;
        case 'subscribe':
            gateway = 'https://prod-34.eastus.logic.azure.com/workflows/3478d2df525e40728cee1bda22f7626d/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=CQQwBDFtBcBJ8BIL32RaYdlnEJic_CRldDg3-pnLDxo';
            break;
        case 'dedicated':
            gateway = 'https://prod-17.eastus.logic.azure.com/workflows/8e3e9ebb4e6b4df293de5141ef702562/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=cwjyboGg-rRdjWFlYqbFZZIv5wSK4I0RsbgpakrkDwg';
            mutinyFormName = 'Contact-Us-Form-Dedicated';
            formLocation = 'new-page';
            break;
        case 'banner':
            gateway = 'https://prod-34.eastus.logic.azure.com:443/workflows/aeee777b2ff9425797fee71e078f6fa3/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=_m9nlaYHlCHEkm82Gqx5kmH3IJWmqF0TgbSPpg4tEDk';
            mutinyFormName = 'Banner-Form';
            formLocation = 'Banner-Signup-Blog-Newsletter';
            break;
        case 'lp-assessment':
            gateway = 'https://prod-37.eastus.logic.azure.com:443/workflows/d7a170a6f19b43a1bbc0c9367ffa9173/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=ZD3m17bIoZiFrBaiawF6G2YAX3HkkSCNt2Pl2H2voig',
            mutinyFormName = 'mkto-form-enrichment',
            formLocation = 'lp-assessment';
            break;
    }

    if (devMode) formFakeDataFill(formFields);

    //Event listener
    form.addEventListener('submit', async function (event) {
        displayLoader(false);
        event.preventDefault();
        //TODO remove jquery stuff!
        $(submitButton).prop('disabled', true);
        $(submitButton).html('Processing...')
        if (errorMessage) $(errorMessage).hide();

        //Recaptcha
        const score = await Recaptcha();
        if (score > 0.5) {
            if (parsleyForm.isValid()) {
                displayLoader(true);
                const data = buildJSONObject(formFields, url, referrer, mktoCookie, formType, formLocation, mutinyFormName);
                try {
                    const submission = await submitForm(gateway, data);
                    handleSuccess(form, successContainer, formType, mutinyFormName, formLocation)
                }
                catch (error) {
                    handleError(error)
                }
            }
            else {
                displayLoader(false);
                errorMessage.innerHTML('Invalid form')
                errorMessage.show()
            }
        }
        else {
            displayLoader(false);
            errorMessage.innerHTML('Invalid recaptcha. Please try again.')
            errorMessage.show()
        }
        
    })
}
function submitGoogleAnalyticsEvent(form, formLocation) {
    //formLocation is unique
    window.dataLayer.push({
        'event': 'form',
        'formLocation': formLocation
    });
}
function submitLinkedinEvent() {
    window.lintrk('track', { conversion_id: 6985714 });
}
function submitMutinyEvent(form, mutinyFormName) {
    window.mutiny.client.trackConversion({ name: mutinyFormName });
    //Banner form is small and doesn't have same form fields as other forms. So it gets a special call out here
    //Assessment now gets the same treatment
    if (mutinyFormName === "Banner-Form" || mutinyFormName === "mkto-form-enrichment") {
        window.mutiny.client.identify(null, {
            name: "",
            email: form.querySelector('input[data-formField="email"]').value,
            title: ""
        })
    }
    //Finally all the rest
    else {
        window.mutiny.client.identify(null, {
            name: form.querySelector('input[data-formField="firstName"]').value + ' ' + form.querySelector('input[data-formField="lastName"]').value,
            email: form.querySelector('input[data-formField="email"]').value,
            title: form.querySelector('input[data-formField="title"]').value
        })
    }
}
function displayLoader(show) {
    if (show) {
        $("#loader-wrapper").show();
    }
    else {
        $("#loader-wrapper").hide();
    }
}
function handleError(error) {
    displayLoader(false);
    //alert(error);
}
function handleSuccess(form, successContainer, formType, mutinyFormName, backupLocation) {
    displayLoader(false);
    //We need to make sure form is the dedicated type first. That has it's own special way to display success
    if (formType !== 'dedicated') {
        $(form).hide();
        $(successContainer).show();
    }
    else {
        const hideFormContainer = $('#contactUsPageHideContainer');
        const thankYouMessage = $('#thankYouContainer');
        form.classList.add('section__form__fields__thankyou');
        hideFormContainer.hide()
        thankYouMessage.show()
    }
    try {

        submitMutinyEvent(form, mutinyFormName);
    }
    catch (e) {
        console.log('error - ', e);
    }

    const formLocation = form.querySelector('input[data-formField="formLocationName"]');
    if (formLocation != null || formLocation != undefined) {
        try {
            submitGoogleAnalyticsEvent(form, formLocation.value);
        }
        catch (e) {
            console.log("error from input try: ", e);
        }
    }
    else {
        try {
            submitGoogleAnalyticsEvent(form, backupLocation);
        }
        catch (e) {
            console.log("Error from backup location: ", e);
        }
    }
    submitLinkedinEvent()
    
}
function buildJSONObject(formFields, url, referrer, cookie, formType, formLocation, mutinyFormName) {
    const certBody = [];
    let jsonObject = {
        pageUrl: url,
        referrer: referrer,
        mktoCookie: cookie,
        contactMe: false,
        source: "",
        sourceAdwords: "",
        sourceCampaignID: "",
        sourceInsight: "",
        sourceSocial: "",
        subject: "",
        marketoFormId: "",
        mutinyFormName: mutinyFormName != undefined ? mutinyFormName : "",
        formLocationName: formLocation != undefined ? formLocation : "" 
    }
    for (const field of formFields) {
        if (field.dataset.formfield === 'contactMe') continue;
        if (field.dataset.formfield === 'assessmentFormId') {
            jsonObject['formId'] = parseInt(field.value);
        }
        if (field.dataset.formfield === 'SHRM' || field.dataset.formfield === 'HRCI') {
            certBody.push(field.dataset.formfield);
            continue;
        }
        if (
            field.dataset.formfield === 'blogSub' ||
            field.dataset.formfield === 'podcastSub' ||
            field.dataset.formfield === 'eventSub' ||
            field.dataset.formfield === 'newsletterSub' ||
            field.dataset.formfield === 'unsubscribed'
        ) {
            const key = field.dataset.formfield;
            let value;
            if (field.checked) {
                value = 'true';
            }
            else {
                value = 'false'
            }
            jsonObject[key] = value;
            continue;
        }
        //if we're testing locally, we want to manually change the ip address so our endpoint doesn't complain. 
        if (field.dataset.formfield === 'ipAddress') {
            if (field.value == '::1') {
                const key = field.dataset.formfield;
                const value = "192.168.000.000";
                jsonObject[key] = value;
                continue;
            }
        }
        //All kinds of special exceptions above. Otherwise we just do this.
        const key = field.dataset.formfield;
        const value = field.value;
        jsonObject[key] = value;
    }
    if (formType === 'workshop') {
        const key = 'certifyingBody';
        const value = certBody;
        jsonObject[key] = value;
    }
    return JSON.stringify(jsonObject);
}
function formFakeDataFill(fields) {
    for (const field of fields) {
        if (field.type === "text") {
            //if it's an email give it a special value
            if (field.dataset.formfield === 'email') {
                field.value = 'test@email.com'
            }
            //if it's phone or zip, give it number
            else if (field.dataset.formfield === 'zip' || field.dataset.formfield === 'phone') {
                field.value = '555555'
            }
            //otherwise just text string
            else {
                field.value = 'test value'
            }
        }
        else if (field.type === "textarea") {
            field.value = "test comments"
        }
        else if (field.type === 'select-one') {
            field.value = "United States"
        }
    }
}
function fillGclidValue(form) {
    const gclidInput = form.querySelector('input[data-formField="gclid"]');
    if (localStorage.getItem("gclid") !== null && gclidInput !== null) {
        gclidInput.value = localStorage.getItem("gclid");
    }
}

//Find all forms and run validator on them. 
let formList = document.querySelectorAll('form[data-submissiontype]');
const developerMode = false;
for (const form of formList) {
    //Running same personal email validation on banner as on wizard. Maybe in future this will apply to all email inputs rather than those 2 only.
    if (form.dataset.submissiontype === "banner") {
        initBannerSignupValidation();
    }
    fillGclidValue(form);
    validate(form, form.dataset.submissiontype, developerMode);
}